import DeliveryBoxesIconlyPro from '@/components/common/icons/DeliveryBoxesIconlyPro'
import DocumentsIcon from '@/components/common/icons/DocumentsIcon'
import PenIconlyPro from '@/components/common/icons/PenIconlyPro'
import PinIconlyPro from '@/components/common/icons/PinIconlyPro'
import UserEditIcon from '@/components/common/icons/UserEditIcon'

export interface IRegStep {
  id: number
  RightIcon: typeof DeliveryBoxesIconlyPro
  title: string
  text: string
}

export const regStepsData: Record<string, IRegStep> = {
  regApply: {
    id: 1,
    RightIcon: UserEditIcon,
    title: 'ثبت مشخصات فروشنده',
    text:
      'در اولین مرحله، اطلاعات شخصی، تماس و جزئیات پایه فروشگاه را وارد می‌کنید تا حساب شما برای ادامه فرایند ثبت‌نام آماده شود.'
  },
  regIdentity: {
    id: 2,
    RightIcon: DeliveryBoxesIconlyPro,
    title: 'انتخاب دسته‌بندی فعالیت',
    text:
      'سپس نوع کسب‌وکار و دسته‌بندی محصولات خود را مشخص می‌کنید تا آپولون بداند در کدام گروه فروشگاهی شما قرار می‌گیرید.'
  },
  regAmount: {
    id: 3,
    RightIcon: PinIconlyPro,
    title: 'ثبت آدرس فروشگاه',
    text:
      'در این مرحله، آدرس دقیق فروشگاه یا انبار، کدپستی و جزئیات مکانی را وارد می‌کنید تا فرآیند بررسی و تحویل با دقت انجام شود.'
  },
  regReview: {
    id: 4,
    RightIcon: DocumentsIcon,
    title: 'بارگذاری مدارک',
    text:
      'مدارک لازم مانند شناسه ملی، شناسنامه، مجوز کسب یا مدارک شرکت، و سایر اسناد مورد نیاز را به‌صورت دیجیتال آپلود می‌کنید.'
  },
  regRecharge: {
    id: 5,
    RightIcon: PenIconlyPro,
    title: 'تأیید و امضای قرارداد',
    text:
      'در نهایت، قرارداد همکاری را بررسی می‌کنید و با امضای دیجیتال یا بارگذاری امضا، درخواست خود را برای بررسی نهایی ارسال می‌کنید.'
  }
}
